import { PureComponent } from 'react';

import CmsBlock from 'Component/CmsBlock';
import ExpandableContent from 'Component/ExpandableContent';

import './PaymentDeadline.style';

/** @namespace Pwa/Component/PaymentDeadline/Component */
export class PaymentDeadline extends PureComponent {
    state = {
        isExpanded: false,
    };

    handleIsExpanded() {
        const { isExpanded } = this.state;
        this.setState({ isExpanded: !isExpanded });
    }

    renderContent() {
        return <CmsBlock identifier="payment_deadline_pdp" />;
    }

    render() {
        const { name } = this.props;
        const { isExpanded } = this.state;

        return (
            <div block="PaymentDeadline" id="PaymentDeadline" onClick={this.handleIsExpanded.bind(this)}>
                <ExpandableContent
                    mix={{ block: 'PaymentDeadline', elem: 'Content' }}
                    heading={name}
                    isExpandableOnDesktop
                    isContentExpanded={isExpanded}
                    iconVariant="secondary"
                >
                    {this.renderContent()}
                </ExpandableContent>
            </div>
        );
    }
}

export default PaymentDeadline;
